import $ from "jquery";
import { toggleItem } from "../../../../js/toggle.js";

( () => {
    $( document ).ready( function () {
    	$('.accordion__panel').slideUp();
    	toggleItem('data-accordion-toggle');
    } );
} )();


// WEBPACK FOOTER //
// ./resources/views/library/components/accordion/accordion.js